import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: {
    roleNames: '',
    createdDate: '',
    createdUser: '',
    updatedDate: '',
    updatedUser: '',
    status: true,
    userRoleSettings: [],
  },
  selectedRoleID: '',
};

export const createRole = createSlice({
  name: 'createRole',
  initialState,
  reducers: {
    updateRoleInfo: (state, action) => {
      state.role = action.payload;
    },
    updateRoleInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.role[field] = value;
    },
    selectRole: (state, action) => {
      state.selectedRoleID = action.payload;
    },
    resetSelectedRole: (state) => {
      state.selectedRoleID = initialState.selectedRoleID;
    },
    clearRoleInfo: (state) => {
      state.role = initialState.role;
    },
  },
});

export const roleDetailSelector = (state) => state.createRole.role;
export const selectedRoleIDSelector = (state) =>
  state.createRole.selectedRoleID;
export const {
  updateRoleInfo,
  updateRoleInfoField,
  clearRoleInfo,
  selectRole,
  resetSelectedRole,
} = createRole.actions;

export const createRoleReducer = createRole.reducer;
export const createRoleReducerName = createRole.name;

export default createRole.reducer;
